// import React, { useEffect, useState } from 'react'
// import { Button } from '@nextui-org/react'
// import { IconSearch, IconTrash } from '@tabler/icons-react'
// import authQueries from '../../queries/authQueries'
// import Empty from '../../components/Empty'
// import DrawerComponent from '../../components/DrawerComponent'
// import { snackbarToast } from '../../components/SnackbarToast'
// import Loader from '../../components/Loader'
// import StatusType from '../../components/StatusType'
// import { useSelector } from 'react-redux'
// import PaginationComponent from '../../components/PaginationComponent'
// import { useApi } from '../../utils/ApiProvider'
// import holidayQueries from '../../queries/holidayQueries'
// import moment from 'moment'


// const HolidayScreen = () => {

//     const [result, setResult] = useState([])
//     const page = useSelector((state)=> state.pagination.page)
//     const size = useSelector((state)=> state.pagination.size)

//     const { apiData, setApiDataAndNotify } = useApi()

//     const inputFields = [
//         {
//             name: 'name',
//             type: 'text',
//             label: 'Title',
//             placeholder: 'Title',
//             required: true
//         },
//         {
//             name: 'date',
//             type: 'date',
//             label: 'Date',
//             placeholder: 'Date',
//             required: true,
//         }
//     ]

//     const getData = holidayQueries.useGetHoliday(
//         (res)=>{
//             if(res?.success){
//                 setResult(res?.data)
//             }
//         }
//     )

//     useEffect(() => {
//         getData.mutateAsync({page, size})
//     }, [apiData, page, size]);
    
//     const create = holidayQueries.useCreateHoliday(
//         (res)=>{
//             if(res?.success){
//               setApiDataAndNotify(new Date())
//             }
//             if(!res?.success){
//               snackbarToast(res?.message, 'error')
//             }
//         }
//     )

//     const update = holidayQueries.useUpdateHoliday(
//         (res)=>{
//             if(res?.success){
//               setApiDataAndNotify(new Date())
//             }
//             if(!res?.success){
//               snackbarToast(res?.message, 'error')
//             }
//         }
//     )
    
//     const deleteHoliday = holidayQueries.useDeleteHoliday(
//         (res)=>{
//             if(res?.success){
//               setApiDataAndNotify(new Date())
//             }
//             if(!res?.success){
//               snackbarToast(res?.message, 'error')
//             }
//         }
//     )

//     const handleDelete = (id) => {
//         deleteHoliday.mutateAsync(id)
//     }

//   return (

//     <div className='card-shadow m-4 max-[768px]:m-2 bg-white rounded-[10px]'>

//         <div className='flex justify-between max-[934px]:flex-col items-center px-[25px] py-5 gap-y-3'>
//             <div>
//                 <p className='text-[13px] text-[#6D6B77] font-medium'>Showing {result?.totalItems} entries</p>
//             </div>
//             <div className='flex gap-2 max-[799px]:flex-col max-[799px]:w-full'>
//                 <DrawerComponent entityForm={create} inputFields={inputFields} btnName={'Add Holiday'} header={'Add Holiday'} />
//             </div>
//         </div>

//         {
//             getData?.isLoading ?
//             <div className="w-full flex items-center justify-center py-40">
//                 <Loader />
//             </div>:
//             <div className='px-6 pb-6'>
//                 {
//                     result?.totalItems > 0 ?
//                         <table className='table w-full'>
//                             <thead>
//                                 <tr className='table-row'>
//                                     <th width="70px">Sl No.</th>
//                                     <th>Title</th>
//                                     <th>Date</th>
//                                     <th></th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {result?.items?.map((row, index) => {
//                                     return(
//                                         <tr key={index} className='table-row'>
//                                             <td>{index+1}</td>
//                                             <td>{row?.name}</td>
//                                             <td className='py-3'>{moment(row?.date).format('Do MMMM YYYY')}</td>
//                                             <td>
//                                                 <div className='flex gap-2 justify-end'>
//                                                     <DrawerComponent entityForm={update} inputFields={inputFields} btnName={'Update Holiday'} header={'Update Holiday'} item={row} edit={true} />
//                                                     <Button onClick={() => handleDelete(row?.id)} color='danger' isIconOnly size='sm'>
//                                                         <IconTrash size="16" />
//                                                     </Button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     )}
//                                 )}
//                             </tbody>
//                         </table>:
//                     <Empty />
//                 }
//             </div>
//         }

//         <PaginationComponent result={result} />

//     </div>
//   )
// }

// export default HolidayScreen




import React, { useState, useEffect } from 'react';
import moment from 'moment';
import holidayQueries from '../../queries/holidayQueries'
import { IconChevronLeft, IconChevronRight, IconPlus, IconX } from '@tabler/icons-react';
import HolidayModal from './HolidayModal';
import { useApi } from '../../utils/ApiProvider';
import { snackbarToast } from '../../components/SnackbarToast';

const CalendarWithSidebar = () => {

    const { apiData, setApiDataAndNotify } = useApi()

    const getData = holidayQueries.useGetHoliday(
        (res)=>{
            if(res?.success){
              setEvents(res?.data)
            }
        }
    )

    useEffect(() => {
        getData.mutateAsync()
    }, [apiData]);
    
    const [currentDate, setCurrentDate] = useState(moment());
    const [selectedDate, setSelectedDate] = useState(moment());

    const [events, setEvents] = useState([]);

    const [sidebarView, setSidebarView] = useState('datepicker'); // datepicker, upcoming

    // Calendar Navigation
    const prevPeriod = () => {
      setCurrentDate(moment(currentDate).subtract(1, 'month'));
    };

    const nextPeriod = () => {
      setCurrentDate(moment(currentDate).add(1, 'month'));
    };

    const goToToday = () => {
        setCurrentDate(moment());
        setSelectedDate(moment());
    };

    // Check if two dates are the same day
    const isSameDay = (date1, date2) => {
        return moment(date1).isSame(moment(date2), 'day');
    };

    // Get events for a specific day
    const getEventsForDay = (day) => {
        const dayDate = moment(currentDate).date(day);
        return events.find(event => isSameDay(event.date, dayDate));
    };

    // Handle date selection
    const handleDateClick = (day) => {
        const newSelectedDate = moment(currentDate).date(day);
        setSelectedDate(newSelectedDate);
    };

    const deleteHoliday = holidayQueries.useDeleteHoliday(
      (res)=>{
          if(res?.success){
            setApiDataAndNotify(new Date())
          }
          if(!res?.success){
            snackbarToast(res?.message, 'error')
          }
      }
    )

    const handleDelete = (id) => {
      deleteHoliday.mutateAsync(id)
    }

    // Generate calendar grid
    const renderCalendarDays = () => {
      const firstDay = moment(currentDate).startOf('month').day();
      const daysInMonth = moment(currentDate).daysInMonth();
      const calendarDays = [];

      // Add empty cells for days before the first day of the month
      for (let i = 0; i < firstDay; i++) {
        calendarDays.push(
          <div key={`empty-${i}`} className="bg-gray-50 border border-gray-200 p-2 h-32 rounded-[10px]"></div>
        );
      }

      // Add cells for each day of the month
      for (let day = 1; day <= daysInMonth; day++) {
        const dayEvent = getEventsForDay(day);
        const isToday = isSameDay(moment(currentDate).date(day), moment());
        const isSelected = isSameDay(moment(currentDate).date(day), selectedDate);
        
        calendarDays.push(
          <div 
            key={`day-${day}`}
            className={`border border-gray-200 p-2 h-32 rounded-[10px] transition-all duration-200 overflow-hidden ${
              isToday ? 'bg-blue-50' : 'bg-white'
            } ${isSelected ? 'ring-2 ring-blue-500' : ''} hover:bg-gray-50 cursor-pointer`}
            onClick={() => handleDateClick(day)}
          >
            <div className="flex justify-between items-center mb-1">
              <span className={`text-nd font-medium ${isToday ? 'bg-blue-500 text-white rounded-full w-7 h-7 flex items-center justify-center' : ''}`}>
                {day}
              </span>
              {isSelected && (
                dayEvent ? (
                  <HolidayModal title="Edit Holiday" isEdit selectedDate={selectedDate} item={dayEvent} />
                ):
                <HolidayModal title="Create Holiday" isEdit={false} selectedDate={selectedDate} />
              )}
            </div>
            <div className="space-y-1">
                <div 
                  key={dayEvent?.id}
                  className="text-md p-1 rounded overflow-auto max-h-20 hide-scrollbar"
                  style={{ backgroundColor: `${dayEvent?.color}20`, borderLeft: `3px solid ${dayEvent?.color}` }}
                >
                  {dayEvent?.title}
                </div>
            </div>
          </div>
        );
      }

      return calendarDays;
    };

    // Render mini calendar for sidebar
    const renderMiniCalendar = () => {
      const firstDay = moment(currentDate).startOf('month').day();
      const daysInMonth = moment(currentDate).daysInMonth();
      
      const dayHeaders = ['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
        <div key={day} className="text-xs text-center text-gray-500 py-1 w-6">
          {day}
        </div>
      ));
      
      const miniCalendarDays = [];
      
      // Add empty cells for days before the first day of the month
      for (let i = 0; i < firstDay; i++) {
        miniCalendarDays.push(
          <div key={`mini-empty-${i}`} className="w-6 h-6"></div>
        );
      }
      
      // Add cells for each day of the month
      for (let day = 1; day <= daysInMonth; day++) {
        const isToday = isSameDay(moment(currentDate).date(day), moment());
        const isSelected = isSameDay(moment(currentDate).date(day), selectedDate);
        const hasEvents = getEventsForDay(day)
        
        miniCalendarDays.push(
          <div 
            key={`mini-day-${day}`}
            className={`w-6 h-6 rounded-full flex items-center justify-center text-xs cursor-pointer
              ${isToday ? 'bg-blue-500 text-white' : ''}
              ${isSelected && !isToday ? 'bg-blue-100' : ''}
              ${hasEvents && !isToday && !isSelected ? 'font-bold' : ''}
              hover:bg-gray-100`}
            onClick={() => handleDateClick(day)}
          >
            {day}
          </div>
        );
      }
      
      return (
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium">
              {moment(currentDate).format('MMMM YYYY')}
            </span>
            <div className="flex space-x-1">
              <button
                className="p-1 text-xs hover:bg-gray-100 rounded"
                onClick={() => setCurrentDate(moment(currentDate).subtract(1, 'month'))}
              >
                <IconChevronLeft size={16} />
              </button>
              <button
                className="p-1 text-xs hover:bg-gray-100 rounded"
                onClick={() => setCurrentDate(moment(currentDate).add(1, 'month'))}
              >
                <IconChevronRight size={16} />
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-7 gap-1">
            {dayHeaders}
            {miniCalendarDays}
          </div>
        </div>
      );
    };

    // Render upcoming events for sidebar
    const renderUpcomingEvents = () => {
      const now = moment();
      const upcomingEvents = events
        .filter(event => moment(event.date).isAfter(now))
        .sort((a, b) => moment(a.date).diff(moment(b.date)))
      
      return (
        <div className="space-y-3">
          <h3 className="text-sm font-medium">Upcoming Events</h3>
          <div className='overflow-y-auto max-h-[400px] hide-scrollbar space-y-3'>
            {upcomingEvents.map(event => (
              <div key={event.id} className="text-sm relative">
                <button onClick={()=>handleDelete(event?.id)} className="absolute right-1 top-1">
                  <IconX size={16} color={event.color} />
                </button>
                <div 
                  className="p-2 rounded space-y-1"
                  style={{ backgroundColor: `${event.color}10`, borderLeft: `3px solid ${event.color}` }}
                >
                  <div className="font-medium text-[14px]">{event.title}</div>
                  <div className="text-[12px] text-gray-600">
                    {moment(event.date).format('Do MMMM YYYY')}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {upcomingEvents.length === 0 && (
            <div className="text-sm text-gray-500">No upcoming events</div>
          )}
        </div>
      );
    };

    // Render sidebar
    const renderSidebar = () => {
      return (
        <div className="bg-white rounded-lg shadow p-4 w-64">
          <div className="flex gap-2 mb-4">
            <button 
              className={`text-xs px-3 py-1 rounded transition-colors ${
                sidebarView === 'datepicker' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100'
              }`}
              onClick={() => setSidebarView('datepicker')}
            >
              Date Picker
            </button>
            <button 
              className={`text-xs px-3 py-1 rounded transition-colors ${
                sidebarView === 'upcoming' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100'
              }`}
              onClick={() => setSidebarView('upcoming')}
            >
              Upcoming
            </button>
          </div>
          
          {sidebarView === 'datepicker' ? renderMiniCalendar() : renderUpcomingEvents()}
          
          <HolidayModal title="Add Holiday" selectedDate={selectedDate}>
            <div className="w-full mt-4 bg-blue-500 text-white rounded py-2 text-sm hover:bg-blue-600 transition-colors">
              Create Holiday
            </div>
          </HolidayModal>
        </div>
      );
    };

  return (
    <div className="flex gap-4 mx-auto">

      {renderSidebar()}
      
      {/* Main Calendar */}
      <div className="bg-white rounded-lg shadow p-4 flex-1">
        {/* Calendar Header */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center space-x-2">
            <h2 className="text-xl font-semibold">
              {moment(currentDate).format('MMMM YYYY')}
            </h2>
            <button 
              className="text-sm bg-blue-50 text-blue-600 px-3 py-1 rounded hover:bg-blue-100"
              onClick={goToToday}
            >
              Today
            </button>
          </div>
          <div className="flex space-x-2">
            <button 
              className="p-2 hover:bg-gray-100 rounded"
              onClick={prevPeriod}
            >
              <IconChevronLeft size={22} />
            </button>
            <button 
              className="p-2 hover:bg-gray-100 rounded"
              onClick={nextPeriod}
            >
              <IconChevronRight size={22} />
            </button>
          </div>
        </div>
        
        {/* Day Headers */}
        <div className="grid grid-cols-7 gap-1 mb-1">
          {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => (
            <div key={day} className="text-sm font-medium text-gray-500 text-center py-2">
              {day}
            </div>
          ))}
        </div>
        
        {/* Calendar Grid */}
        <div className="grid grid-cols-7 gap-1">
          {renderCalendarDays()}
        </div>
        
      </div>
    </div>
  );
};

export default CalendarWithSidebar;